import React from 'react';
import SmileImg from '../../../assets/images/smile.svg';
import {
  WithoutDataContainer,
  WithoutDataText,
  WithoutDataTextWrapper
} from './styles';

export const WithoutData = () => {
  return (
    <WithoutDataContainer>
      <img src={SmileImg} alt="Imagem de smile" />
      <WithoutDataTextWrapper>
        <WithoutDataText>
          Ainda não há manifestações de aços longos ou de aços planos.
        </WithoutDataText>
      </WithoutDataTextWrapper>
    </WithoutDataContainer>
  );
};
